import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { IconName } from '../icon/icons';
import { IDynamicElement } from '../_shared/models/dynamic/dynamic-element.model';
import { IHighlightItem } from '../_shared/models/highlight-item.model';
import { IconComponent } from '../icon/icon.component';

@Component({
    selector: 'sirius-highlighted-item',
    templateUrl: './highlighted-item.component.html',
    styleUrls: ['./highlighted-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'sir-text-style-paragraph-m-default' },
    imports: [IconComponent]
})
export class HighlightedItemComponent implements IDynamicElement<IHighlightItem> {
    readonly config = input<IHighlightItem>();
    readonly label = input('');
    readonly value = input('');
    readonly icon = input<IconName>('house');

    readonly resolvedLabel = computed(() => this.config()?.label ?? this.label());
    readonly resolvedValue = computed(() => this.config()?.value ?? this.value());
    readonly resolvedIcon = computed<IconName>(() => this.config()?.icon.icon ?? this.icon());
}
